import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const HomeScreen = () => {
    const handleScroll = () => {
        console.log('scroll')
    }
    return (
        <Container>
            <p className='brand'></p>
            <p className='brand'>
                I am <span className='uppercase'>Naheel Palliyali</span>
            </p>
            <div className='title'>
                {[...Array(5)].map((e, idx) => (
                    <div
                        className='title__container role'
                        key={idx}
                        onScroll={handleScroll}
                        style={{ '--index': `${idx * 0.7}` }}
                    >
                        <h1 className='title--outline'>Creative</h1>
                        <h1 className='title--outline'>Developer</h1>
                        <h1 className='title--outline'>Creative</h1>
                        <h1 className='title--outline'>Developer</h1>
                        <h1 className='title--outline'>Creative</h1>
                        <h1 className='title--outline'>Developer</h1>
                        <h1 className='title--outline'>Creative</h1>
                        <h1 className='title--outline'>Developer</h1>
                        <h1 className='title--outline'>Creative</h1>
                    </div>
                ))}
            </div>
        </Container>
    )
}

export default HomeScreen

const Container = styled.div`
    padding-top: 17vh;
    height: 100vh;
    width: 100vw;
    overflow: hidden;

    .title__container {
        display: flex;
        width: 100vw;
        margin-top: -1.9vw;
        position: relative;
        right: calc(54vw * var(--index));
        transition: all 600ms cubic-bezier(0.4, 0, 0, 0.8);
    }

    .title__container:hover {
        position: relative;
        right: calc(30vw + 54vw * var(--index));
    }

    .title {
        overflow: hidden;
        font-size: calc(1rem + 3.1vw);
        font-weight: 700;
        text-transform: uppercase;
        height: calc(3.4 * 26vh);
    }

    .title--solid::selection {
        user-select: none;
    }
    .title--outline::selection {
        user-select: none;
    }

    .title--solid {
        color: var(--color-dark);
        transition: 650ms cubic-bezier(0.4, 0, 0, 0.8);
        cursor: default;
    }

    .title--solid:hover {
        color: var(--color-light);
        text-shadow: -1px 0 0 var(--color-dark), 0 1px 0 var(--color-dark),
            1px 0 0 var(--color-dark), 0 -1px 0 var(--color-dark);
    }

    .title--outline {
        width: max-content;
        text-align: right;
        color: var(--color-light);
        text-shadow: -1px 0 0 var(--color-dark), 0 1px 0 var(--color-dark),
            1px 0 0 var(--color-dark), 0 -1px 0 var(--color-dark);

        transition: 650ms cubic-bezier(0.4, 0, 0, 0.8);
        cursor: default;
    }

    .title--outline:hover {
        color: var(--color-dark);
    }

    .brand {
        color: var(--color-dark);
        position: absolute;
        top: 8vh;
        left: 6%;
        font-size: 0.9rem;
        font-weight: 300;
        letter-spacing: 2px;
    }

    .uppercase {
        text-transform: uppercase;
        font-weight: 700;
    }

    .hero__text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -80%);
        width: 32%;
        min-width: 320px;
        height: 32%;
        background-color: var(--color-light);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 2rem;
        padding: 4rem;
        white-space: pre-line;
    }
`
